export const BLINK_DURATION: number = 0.1; // Duration in seconds of a single blink during ship's invisibility.
export const SIZE: number = 30; // Ship height in pixels.
